export default async (context) => {
    let theme = await context.$store.getters['theme/theme']
    let music = await context.$store.getters['music/music']

    await context.$axios.post('validateVideos', {
        theme: theme.id,
        music: music.id,
        videos: context.videos
    })
        .then(({ data }) => {
            if(data.success) {
                context.overlay = false
                context.error.status = false
                context.error.push = ''
                context.error.text = ''
                context.loading = false
            } else {
                if(data.error === 'Указанной темы не существует') {
                    context.error.button = 'Поменять тему'
                    context.error.text = data.error
                    // context.error.push = '/theme'
                    context.error.push = '/'
                } else if(data.error === 'Выбран недоступный музыкальный ролик') {
                    context.error.button = 'Сменить музыку'
                    context.error.text = data.error
                    context.error.push = '/add-music'
                } else {
                    context.error.button = 'Вернуться на главную'
                    context.error.text = data.error
                    context.error.push = '/'
                }

                context.overlay = true
                context.error.status = true

            }
        })
        .catch(e => {
            console.error(e)
            context.error.text = 'Ошибка сервера! Повторите попытку позже.'
            context.overlay = true
            context.error.status = true
        })
}